import { Directive, ElementRef, Inject, OnInit } from '@angular/core';
import { Theme, THEME_TOKEN } from '../../types/theme.types';
import { componentStylesByTheme } from '../../utils/theme.utils';
import { style } from '../../utils/style.utils';
import { rangeTrackStylesSAG, rangeTrackStylesSHS } from './range-track.styles';

@Directive({
  selector: '[sag-ui-range-track]',
})
export class RangeTrackDirective implements OnInit {
  constructor(
    @Inject(THEME_TOKEN) private readonly theme: Theme,
    private readonly elementRef: ElementRef<HTMLSpanElement>
  ) {}

  ngOnInit(): void {
    const rangeTrackStyles = componentStylesByTheme(
      this.theme,
      rangeTrackStylesSAG,
      rangeTrackStylesSHS
    );
    style(this.elementRef, rangeTrackStyles());
  }

  public nativeElement(): HTMLElement {
    return this.elementRef.nativeElement;
  }
}
